// extracted by mini-css-extract-plugin
export default {"root":"Item_root__93YG-"};